import { AppChannel, Channel } from "@/config/channel"
import Link from "next/link"
import { SnaiLogo } from "./snai-logo"

type HomePageLogoLinkProps = {
  siteid?: Channel
}

export function HomePageSnaiLogoLink({
  siteid = AppChannel.PortaleWebFullResponsiveWwwSisalIt,
}: HomePageLogoLinkProps) {
  const pathname =
    siteid === AppChannel.PortaleWebFullResponsiveWwwSisalIt
      ? process.env.APP_MAIN_SITE_HOMEPAGE
      : null
  return (
    <Link href={{ pathname }} title="Snai">
      <SnaiLogo />
    </Link>
  )
}
